<template>
    <v-container style="margin-top:10px">
        <v-layout>
            <v-flex xs12 sm12 md8 lg8 xl8 style="margin:auto">
                <v-card >
                    <v-card-text>
                        <div>
                            <post :item="post" :key="post.postId" :editable="false"/>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios/index";
    import ClazzCreate from "../class/createClass";
    import TeacherInfo from "../class/teacherProfile";
    import Post from "./post";

    export default {
        components: {Post, TeacherInfo, ClazzCreate},
        props: {
            objectType: {
                type: String | Number,
                default: 0
            },
            classId: {
                type: String | Number,
                default: null
            },

        },

        computed: {
            styleOfFeed: function () {
                if (this.editting) {
                    return "feed active";
                } else {
                    return "feed";
                }
            },

            backgroundStyle: function () {
                if (this.editting) {
                    return "background show";
                } else {
                    return "background";
                }
            }
        },

        watch: {
            classId: function (data) {
                this.getPost();
            }
        },

        data() {
            return {
                postId:null,
                post: {},
            }
        },

        created() {
            if (this.$route.params.postId) {
                this.postId = this.$route.params.postId;
                this.getPost();
            }
        },
        methods: {
            getPost: function () {
                axios.post(process.env.VUE_APP_API_URL + "/post/getPost?postId="+this.postId).then(
                    data => {
                        this.post = data;
                        console.log(this.posts);
                    },
                    error => {

                    }
                )
            }
        }
    };
</script>